import { schema } from "normalizr";
import { policySchema } from "../policy";

export const organizationSchema = new schema.Entity("organizations", {
  policies: [policySchema]
});
